import './ccf-add-channel-icon.module.scss';
import { SvgIcon , SvgIconProps} from '@mui/material';

/* eslint-disable-next-line */
export interface CcfAddChannelIconProps extends SvgIconProps {}
/**
 * Component used to show add channel Icon
 * @param props - CcfAddChannelIconProps
 * @example - <CcfAddChannelIcon />
 * @returns SVG of add channel icon
 */
export function CcfAddChannelIcon(props: CcfAddChannelIconProps) {
  return (
    <SvgIcon {...props}>
      <g
        id="Add_Channel"
        data-name="Add Channel"
      >
        <g
          id="Add_Contact_Tab"
          data-name="Add Contact Tab"
          transform="translate(6.5 6.5)"
        >
          <path
            id="Add_more"
            d="M9.6,0H2.4A2.407,2.407,0,0,0,0,2.4V9.6A2.407,2.407,0,0,0,2.4,12H9.6A2.407,2.407,0,0,0,12,9.6V2.4A2.407,2.407,0,0,0,9.6,0ZM9,6.6H6.6V9A.6.6,0,0,1,5.4,9V6.6H3A.6.6,0,1,1,3,5.4H5.4V3A.6.6,0,1,1,6.6,3V5.4H9A.6.6,0,0,1,9,6.6Z"
            fill="#526b7a"
            opacity="0.998"
          />
        </g>
      </g>
    </SvgIcon>
  );
}

export default CcfAddChannelIcon;
